import React, { Component } from "react";
import {withNamespaces} from "react-i18next";
import {connect} from "react-redux";
import {networkDeviceActions} from "../../../../actions/network-device.actions";
import {Alert, Button, ProgressBar, Spinner} from "react-bootstrap";
import {Link} from "react-router-dom";
import {modalActions} from "../../../../actions/modal.actions";
import {daliEsSystemActions} from "../../../../actions/dali-es-system.actions";
import BreadcrumbExtend from "../../../../components/BreadcrumbExtend";
import DaliDeviceInfo from "../_components/DaliDeviceInfo";
import DaliEsSystemGroupTable from "./_components/DaliEsSystemGroupTable";
import DaliEsSystemGroupForm from "./_forms/DaliEsSystemGroupForm";

class DaliEsSystemGroupPage extends Component {

    id = null;
    areaId = null;

    componentDidMount() {
        const { dispatch } = this.props;
        this.id = this.props.match.params.id;
        this.areaId = this.props.match.params.areaId;

        dispatch(networkDeviceActions.getNetworkDeviceSimpleInfo(this.id));
        dispatch(daliEsSystemActions.getEsSystemAreaById(this.areaId));
    }

    componentWillUnmount() {
        const { dispatch } = this.props;
        dispatch(daliEsSystemActions.clearGroupFromDevice());
    }

    openModalCreateHelvarGroup = (e) => {
        e.preventDefault();
        const { t, dispatch } = this.props;
        const modalProps = {
            open: true,
            title: t('add_dali-group'),
            component: <DaliEsSystemGroupForm deviceId={this.id} areaId={this.areaId} submitForm={this.handleSubmitCreateGroup}/>
        };

        dispatch(modalActions.showModal({modalProps: modalProps, modalType: 'formModal'}))
    };

    handleSubmitCreateGroup = (model) => {
        const { dispatch } = this.props;
        dispatch(daliEsSystemActions.createEsSystemGroup(model));
    };

    render() {
        const { t, simpleDeviceInfo, loader, loaderMsg, esSystemAreaItem, groupFromDevice } = this.props;
        const breadcrumb = [
            { value: 'network-device', path: '/panel/network-device' },
            { value: simpleDeviceInfo?.label, path: '#' },
            { value: `${t('area')} - ${esSystemAreaItem?.label}`, path: `/panel/network-device/dali/es-system/${this.id}/area` },
            { value: 'dali-groups', path: '#' },
        ];

        const extendInfo = [
            { key: 'area', value: esSystemAreaItem?.label }
        ];

        return(
            <div>
                <BreadcrumbExtend items={breadcrumb}/>
                <DaliDeviceInfo networkDeviceInfo={simpleDeviceInfo} title={'dali-groups'} infoElements={extendInfo}/>

                { groupFromDevice === null ?  (
                    <Alert variant={"warning"} className="col-md-12" >
                        <Spinner animation={"border"} size={"md"} variant={"success"} />
                        <p className="font-weight-bold m-0">{t('waiting-form-response-device')}</p>
                        <p className="m-0">{t('waiting-form-response-device-msg')}</p>
                    </Alert>
                ) : groupFromDevice === 'error' ? (
                    <Alert variant={"danger"} className="col-md-12" >
                        <p className="font-weight-bold m-0">{t('error.connection-error')}</p>
                        <p className="m-0">{t('connection-error-response-device-msg')}</p>
                    </Alert>
                ) : (
                    <Alert variant={"success"} className="col-md-12" >
                        <p className="font-weight-bold m-0">{t('connected')}</p>
                        <p className="m-0">{t('connected-device-ok')}</p>
                    </Alert>
                )}



                { !loader ? (
                    <div className="card">
                        <div className="card-header">
                            <div className="button-group float-right">
                                <Button variant={"success"} disabled={groupFromDevice === null} onClick={this.openModalCreateHelvarGroup}>
                                    <i className="fas fa-plus"/> {t('create')}
                                </Button>
                                &nbsp;
                                <Link to={`/panel/network-device/dali/es-system/${this.id}/area`} className="btn btn-secondary">
                                    <i className="fas fa-undo"> </i> {t('back-to-list-area')}
                                </Link> &nbsp;
                            </div>
                        </div>
                        <div className="card-body">
                            <DaliEsSystemGroupTable list={esSystemAreaItem?.daliEsSystemGroups} device={simpleDeviceInfo} area={esSystemAreaItem}/>
                        </div>
                    </div>
                ) : (
                    <Alert variant={"warning"}>
                        <h4>{t(loaderMsg)}</h4>
                        <Spinner animation={"border"} />
                    </Alert>
                )}
            </div>
        )
    }
}
const mapStateToProps = (state) => {
    const { simpleDeviceInfo, loader, loaderMsg } = state.networkDeviceReducer;
    const { esSystemAreaItem, groupFromDevice } = state.daliEsSystemReducer;

    return {
        simpleDeviceInfo, esSystemAreaItem, groupFromDevice, loader, loaderMsg
    }
};
export default withNamespaces()(connect(mapStateToProps)(DaliEsSystemGroupPage))
